export default __webpack_public_path__ + "static/media/1921.59d84b71.png";